
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"58","height":"58","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"29","cy":"29","r":"27.5","stroke":"#161F32","stroke-width":"3"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.5 20.88a5.38 5.38 0 015.38-5.38h16.24a5.38 5.38 0 015.38 5.38v20.776a.844.844 0 01-1.688 0V20.881a3.693 3.693 0 00-3.693-3.694H20.881a3.693 3.693 0 00-3.694 3.694v20.775a.844.844 0 01-1.687 0V20.881zm3.67.327a2.05 2.05 0 012.051-2.05h4.885a2.05 2.05 0 012.05 2.05v4.899a2.05 2.05 0 01-2.05 2.05H21.22a2.05 2.05 0 01-2.05-2.05v-4.9zm2.051-.363c-.2 0-.363.162-.363.363v4.899c0 .2.163.363.363.363h4.885c.2 0 .363-.163.363-.363v-4.9c0-.2-.163-.362-.363-.362H21.22zm8.623.363a2.05 2.05 0 012.05-2.05h4.885a2.05 2.05 0 012.05 2.05v4.899a2.05 2.05 0 01-2.05 2.05h-4.885a2.05 2.05 0 01-2.05-2.05v-4.9zm2.05-.363c-.2 0-.363.162-.363.363v4.899c0 .2.163.363.363.363h4.885c.2 0 .363-.163.363-.363v-4.9c0-.2-.163-.362-.363-.362h-4.885zm-12.723 11.05a2.05 2.05 0 012.05-2.05h4.885a2.05 2.05 0 012.05 2.05v4.9a2.05 2.05 0 01-2.05 2.05H21.22a2.05 2.05 0 01-2.05-2.05v-4.9zm2.05-.363c-.2 0-.363.163-.363.363v4.9c0 .2.163.362.363.362h4.885c.2 0 .363-.162.363-.363v-4.899c0-.2-.163-.363-.363-.363H21.22zm8.623 2.813c0-2.48 2.009-4.5 4.492-4.5a4.499 4.499 0 014.493 4.5c0 2.479-2.01 4.5-4.492 4.5a4.499 4.499 0 01-4.493-4.5zm4.492-2.813a2.812 2.812 0 00-2.805 2.813 2.811 2.811 0 002.806 2.812 2.811 2.811 0 002.805-2.812 2.811 2.811 0 00-2.806-2.813z","fill":"#202D38"}})])
          )
        }
      }
    